import { BrandNotFound } from '@/app/components/BrandNotFound/BrandNotFound'
import SurveyObserver from '@/app/components/SurveyObserver'
import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'
import { useLocation } from 'react-router-dom'

export default function BrandNotFoundPageSurvey() {
  const isAva = useIsAvaBasePath()
  const isOnboarding = useLocation().pathname.includes('/onboarding/')
  const redirectLink =
    isAva && isOnboarding
      ? '/ava/connect-device/vehicle?onboarding=true'
      : '/connect-device/vehicle'
  return (
    <SurveyObserver observedSurveys={['MissingBrand']}>
      <BrandNotFound
        type="charger"
        brandPlaceholder="Charger Brand"
        modelPlaceholder="Charger Model"
        redirect={{
          link: redirectLink,
          device: 'vehicle',
        }}
      />
    </SurveyObserver>
  )
}
